import React, { useState, FormEvent, useContext, useEffect } from "react";
import { Segment, Form, Button, Dropdown } from "semantic-ui-react";
import { IProject } from "../../../app/models/project";
import MinorStore from "../../../app/stores/minorStore";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router";

interface DetailParams {
  id: string;
}

const MinorEditForm: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history,
}) => {
  const minorStore = useContext(MinorStore);
  const {
    createProject,
    editProject,
    project: initialFormState,
    loadProject,
    clearProject,
    submitting,
  } = minorStore;

  const [project, setProject] = useState<IProject>({
    id: "",
    createdAt: "",
    updatedAt: "",
    projectCode: "",
    jobType: "",
    category: "",
    customerId: "",
    workType: "",
    siteId: "",
    siteName: "",
    orderNumber: "",
    materialOrderNo: "",
    status: "",
    address: "",
    receiveDate: "",
    requireDate: "",
    jobStartDate: "",
    estimatedCompletionDate: "",
    invoiceNo: "",
    remark: "",
  });

  useEffect(() => {
    loadProject(match.params.id).then(
      () => initialFormState && setProject(initialFormState)
    );

    return () => {
      clearProject();
    };
  }, []);

  const handleSubmit = () => {
    editProject(project).then(() =>
      history.push(`/projectmanagement/minor/${project.id}`)
    );
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProject({ ...project, [name]: value });
  };
  
  const status = [
    { key: "Received", text: "Received", value: "Received" },
    { key: "In-Progress", text: "In-Progress", value: "In-Progress" },
    { key: "Completed", text: "Completed", value: "Completed" },
    {
      key: "Claim Submitted",
      text: "Claim Submitted",
      value: "Claim Submitted",
    },
    {
      key: "Approved for Payment",
      text: "Approved for Payment",
      value: "Approved for Payment",
    },
    {
      key: "Payment Received",
      text: "Payment Received",
      value: "Payment Received",
    },
    { key: "Closed", text: "Closed", value: "Closed" },
    { key: "Onhold", text: "Onhold", value: "Onhold" },
    { key: "Cancel", text: "Cancel", value: "Cancel" },
  ];

  const subconPayment = [
    { key: "Not Paid", text: "Not Paid", value: "Not Paid" },
    { key: "Partial Paid", text: "Partial Paid", value: "Partial Paid" },
    { key: "Paid", text: "Paid", value: "Paid" },
  ];

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
          <Form.Input
            label="Project Code"
            required
            width="8"
            onChange={handleInputChange}
            name="projectCode"
            placeholder="Project Code"
            value={project.projectCode}
          />
          <Form.Input
          label="Work Type"
          required
          width="8"
          onChange={handleInputChange}
          name="workType"
          placeholder="Work Type"
          value={project.workType}
        />
        <Form.Select
            label="Status"
            width='8'
            required
            onChange={(e, { name, value }) =>
            setProject({ ...project, [name]: value })
            }
            options={status}
            name="status"
            placeholder="Status"
            value={project.status}
          />
        <Form.Select
            label="Subcontractor Payment"
            width='8'
            required
            onChange={(e, { name, value }) =>
            setProject({ ...project, [name]: value })
            }
            options={subconPayment}
            name="orderNumber"
            placeholder="Subcontractor Payment"
            value={project.orderNumber}
          />
        <Form.Input
          label="Job Location"
          onChange={handleInputChange}
          name="address"
          placeholder="Job Location"
          value={project.address}
        />
        <Form.TextArea
          label="Remark"
          onChange={handleInputChange}
          name="remark"
          rows={2}
          placeholder="Remark"
          value={project.remark}
        />
        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        />
        <Button
          onClick={() => history.push("/projectmanagement/minor")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(MinorEditForm);
